export class WithdrawalHistory {
    public amount!: number;
    public createdBy!: string;
    public createdDate!: string;
    public id!: number;
    public status!: number;
    public statusDetail!: any;
    public userName!: string;
}